import splitUrlExperiments from '../../split-url-redirects.json';
import handleTrailingSlash from '../../shared/base/utils/handleTrailingSlash';

/**
 * Get split url experiment if it matches with any listed in the Contentful
 * @param {String} pathname
 * @returns {Object}
 */

const isBrowser = typeof window !== 'undefined';

export default function getSplitUrlExperiment(pathname) {
  return splitUrlExperiments.find(experiment => {
    if (
      handleTrailingSlash(experiment?.path) === handleTrailingSlash(pathname) &&
      isBrowser &&
      experiment?.domain === window.location.host
    )
      return experiment;
  });
}
